import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'nav-items-container',
  templateUrl: './nav-items-container.component.html',
  styleUrls: ['./nav-items-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavItemsContainerComponent {}
